import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const AddCircle: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#add-circle-clip-0)">
      <g clipPath="url(#add-circle-clip-1)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 8C18 13.5229 13.5229 18 8 18C2.47716 18 -2 13.5229 -2 8C-2 2.47716 2.47716 -2 8 -2C13.5229 -2 18 2.47716 18 8ZM8 2.64286C8.59173 2.64286 9.07143 3.12256 9.07143 3.71429V6.92857H12.2857C12.8774 6.92857 13.3571 7.40827 13.3571 8C13.3571 8.59173 12.8774 9.07143 12.2857 9.07143H9.07143V12.2857C9.07143 12.8774 8.59173 13.3571 8 13.3571C7.40827 13.3571 6.92857 12.8774 6.92857 12.2857V9.07143H3.71429C3.12256 9.07143 2.64286 8.59173 2.64286 8C2.64286 7.40827 3.12256 6.92857 3.71429 6.92857H6.92857V3.71429C6.92857 3.12256 7.40827 2.64286 8 2.64286Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="add-circle-clip-0">
        <rect width="16" height="16" rx="8" fill="white" />
      </clipPath>
      <clipPath id="add-circle-clip-1">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(-2 -2)"
        />
      </clipPath>
    </defs>
  </svg>
);
